import { http } from '@/http/index'

async function getGuestWelcomeMessage(isLocal) {
	return http.get(`/guest/messenger/init`, { withCredentials: !isLocal }).then((response) => response?.data)
}

export { getGuestWelcomeMessage }
